import { TIPO_CLIENTE } from '@/constants/TipoClienteEnum';

export const STEP_MAPPINGS = {
  [TIPO_CLIENTE.PESSOA_FISICA]: {
    0: 'Informações',
    1: 'Procuradores',
    2: 'Dados Financeiros',
    3: 'Dados Bancários',
    4: 'Endereços',
    5: 'Upload de Documentos',
    6: 'Declarações',
    7: 'Produtos',
    9: 'Questionário Suitability'
  },
  [TIPO_CLIENTE.PESSOA_JURIDICA]: {
    0: 'Dados da Empresa',
    1: 'Procuradores',
    2: 'Representantes',
    3: 'Dados Financeiros',
    4: 'Dados Bancários',
    5: 'Endereço',
    6: 'Documentos',
    7: 'Declarações',
    8: 'Produtos',
    9: 'Questionário Suitability'
  },
  [TIPO_CLIENTE.FUNDOS]: {
    0: 'Dados cadastrais',
    1: 'Procuradores',
    2: 'Participantes',
    3: 'Dados Financeiros',
    4: 'Dados Bancários',
    5: 'Upload de Documentos',
    6: 'Declarações',
    7: 'FATCA',
    8: 'Produtos',
    9: 'Questionário Suitability'
  }
};

export function getStepName(tipoCliente, stepNumber) {
  return STEP_MAPPINGS[tipoCliente]?.[stepNumber] || `Etapa ${stepNumber}`;
}
